import React from 'react';
import WAValidator from 'multicoin-address-validator';
import _ from 'lodash';

const CURRENCIES_VALIDATOR = [{
    name: 'Binance',
    symbol: 'BEP-2',
    addressTypes: {prod: ['bnb']},
}, {
    name: 'Binance',
    symbol: 'BEP-20',
    like: 'ETH'
}, {
    name: 'Matic',
    symbol: 'POLYGON',
    like: 'ETH'
}, {
    name: 'Fantom',
    symbol: 'OPERA',
    like: 'ETH'
}, {
    name: 'Theta',
    symbol: 'THETA',
    like: 'ETH'
},  {
    name: 'Mantle',
    symbol: 'MNT',
    like: 'ETH'
}, {
    name: 'Arbitrum',
    symbol: 'ARB',
    like: 'ETH'
},  {
    name: 'VeChain',
    symbol: 'VET',
    like: 'ETH'
},  {
    name: 'Wemix',
    symbol: 'WEMIX',
    like: 'ETH'
}, {
    name: 'Cosmos',
    symbol: 'COSMOS',
    addressTypes: {prod: ['cosmos']},
}, {
    name: 'Luna',
    symbol: 'TERRA-CLASSIC',
    addressTypes: {prod: ['terra']},
}, {
    name: 'Luna',
    symbol: 'TERRA',
    addressTypes: {prod: ['terra']},
}, {
    name: 'ONE',
    symbol: 'ONE',
    addressTypes: {prod: ['one']},
}, {
    name: 'EGLD',
    symbol: 'EGLD',
    addressTypes: {prod: ['erd']},
}, {
    name: 'TON',
    symbol: 'TON',
    addressTypes: {prod: ['UQ', 'EQ']},
}, {
    name: 'OSMO',
    symbol: 'OSMO',
    addressTypes: {prod: ['osmo']},
}, {
    name: 'HBAR',
    symbol: 'HBAR',
    addressTypes: {prod: ['0']},
}, {
    name: 'HELIUM',
    symbol: 'HNT',
    addressTypes: {prod: ['1']},
}, {
    name: 'ZILIQA',
    symbol: 'ZIL',
    addressTypes: {prod: ['zil']},
}, {
    name: 'SUI',
    symbol: 'SUI',
    addressTypes: {prod: ['0x']},
}, {
    name: 'FIL',
    symbol: 'FIL',
    addressTypes: {prod: ['f']},
}, {
    name: 'NEO',
    symbol: 'NEO3',
    addressTypes: {prod: ['N']},
}, {
    name: 'SEI',
    symbol: 'SEI',
    addressTypes: {prod: ['sei']},
}, {
    name: 'KAS',
    symbol: 'KAS',
    addressTypes: {prod: ['kaspa']},
}, {
    name: 'XDC',
    symbol: 'XDC',
    addressTypes: {prod: ['xdc']},
}, {
    name: 'XPR',
    symbol: 'XPR',
    addressTypes: {prod: ['']},
}, {
    name: 'Akash',
    symbol: 'AKT',
    addressTypes: {prod: ['akash']},
}, {
    name: 'Celestia',
    symbol: 'TIA',
    addressTypes: {prod: ['celestia']},
}, {
    name: 'Aptos',
    symbol: 'APT',
    addressTypes: {prod: ['0x']},
}, {
    name: 'Near',
    symbol: 'NEAR',
    addressTypes: {prod: ['']},
}]

const TRANSACTION_STATUS = {
    CONFIRMED: 0,
    CANCELLED: 1,
    PENDING: 2,
    REJECT: 3,
    DONE: 4,
    SUBMITTED: 5,
    ACCEPTED: 6,
    NEED_CONFIRMATION: 7
}

const validateAddress = (address, ticker_symbol, network) => {
    const _ = require('lodash');

    let pingiValidator = _.find(CURRENCIES_VALIDATOR, {symbol: network});
    let validate = false;

    try {
        if (pingiValidator) {
            if (!validate) {
                if (typeof pingiValidator.like === "undefined") {
                    pingiValidator.addressTypes.prod.map(itemValidation => {
                        let regexTemplate = new RegExp(`^${itemValidation}.*`, 'g')
                        if (regexTemplate.test(address))
                            validate = true
                    })
                } else {
                    return WAValidator.validate(address, pingiValidator.like)
                }
            }
            return validate
        } else {
            return WAValidator.validate(address, ticker_symbol)
        }
    } catch (e) {
        console.log('unsupported symbol')
    }
}

const hexDataShortener = data => {
    if (data.length > 18) {
        let start = data.slice(0, 6)
        let end = data.slice(-6)
        return `${start}...${end}`
    }
    return data;
}

/**
 * Shortens a cryptocurrency wallet address by truncating the middle.
 *
 * @param {string} address - The wallet address to shorten.
 * @param {number} [length=10] - The desired length of the shortened address. Defaults to 10.
 * @returns {string} The shortened wallet address.
 */
const cryptoWalletAddressShorter = (address, length = 10) => {
    if (address && address.length > length) {
        let start = address.slice(0, length)
        let end = address.slice(-length)
        return `${start}...${end}`
    }
    return address;
}

/**
 * Retrieve last update of currency's wallet
 *
 * @param item
 * @returns {null}
 */
const retrieveCryptoWalletUDT = (item) => {
    let udt = null
    if (item?.networks && !_.isEmpty(item.networks)) {
        Object.keys(item.networks).map(networkKey => {
            let network = item.networks[networkKey]
            if (typeof network?.wallet !== 'undefined')
                udt = network.wallet.updated_at
        })
    }
    return udt
}

const checkWalletNeedSync = item => {
    let needSync = false
    if (item?.networks && !_.isEmpty(item.networks)) {
        Object.keys(item.networks).map(networkKey => {
            let network = item.networks[networkKey]
            if (typeof network?.wallet !== 'undefined' && !needSync)
                needSync = network.need_sync
        })
    }
    return needSync
}

/**
 * Check item that pas from wallet page for wallet address in each network
 *
 * @param item
 */
const cryptoItemHasAddress = (item) => {
    let hasAddress = false
    if (item?.networks && !_.isEmpty(item.networks)) {
        Object.keys(item.networks).map(networkKey => {
            let network = item.networks[networkKey]
            if (typeof network?.wallet !== 'undefined')
                hasAddress = true
        })
    }

    return hasAddress
}

/**
 * Check item that pas from wallet page for wallet address in each network
 *
 * @param item
 */
const cryptoItemHasAllNetworkAddresses = (item) => {
    let hasAddress = true
    if (item?.networks && !_.isEmpty(item.networks)) {
        Object.keys(item.networks).map(networkKey => {
            let network = item.networks[networkKey]
            if (typeof network?.wallet === 'undefined')
                hasAddress = false
        })
    }

    return hasAddress
}

export const CryptoHelper = {
    tickerByOrder: {
        'IRT': 0,
        'BTC': 1,
        'ETH': 2,
        'USDT': 3,
        'TRX': 4,
    },
    transactionStatus: TRANSACTION_STATUS,
    transactionStatusTitles: {
        [TRANSACTION_STATUS.CONFIRMED]: 'تایید شده',
        [TRANSACTION_STATUS.CANCELLED]: 'لغو شده',
        [TRANSACTION_STATUS.PENDING]: 'در حال انجام',
        [TRANSACTION_STATUS.REJECT]: 'رد شده',
        [TRANSACTION_STATUS.DONE]: 'انجام شده',
        [TRANSACTION_STATUS.SUBMITTED]: 'در دست بررسی',
        [TRANSACTION_STATUS.ACCEPTED]: 'مورد قبول',
        [TRANSACTION_STATUS.NEED_CONFIRMATION]: 'تعلیق شبکه',
    },
    transactionColorByStatus: {
        [TRANSACTION_STATUS.CONFIRMED]: 'var(--text-color-scondary)',
        [TRANSACTION_STATUS.CANCELLED]: '#FCAB42',
        [TRANSACTION_STATUS.PENDING]: '#2C59D9',
        [TRANSACTION_STATUS.REJECT]: '#EF4343',
        [TRANSACTION_STATUS.DONE]: '#00C275',
        [TRANSACTION_STATUS.SUBMITTED]: '#2C59D9',
        [TRANSACTION_STATUS.ACCEPTED]: '#00C275',
        [TRANSACTION_STATUS.NEED_CONFIRMATION]: '#2C59D9',
    },
    transactionType: {
        TRADE: 0,
        TRANSFER: 1,
        FEE: 2,
        COMMISSION: 3,
        REWARD: 4,
    },
    transactionTypeTitles: {
        0: 'معامله',
        1: 'جابجایی داخلی',
        2: 'کارمزد',
        3: 'هدیه',
        4: 'جایزه',
    },
    TIME_BETWEEN_EACH_SYNC: 5,
    transactionAction: {
        DEPOSIT: 0,
        WITHDRAW: 1
    },
    BTC_SYMBOL: 'BTC',
    validateAddress,
    hexDataShortener,
    cryptoWalletAddressShorter,
    retrieveCryptoWalletUDT,
    cryptoItemHasAddress,
    checkWalletNeedSync,
    cryptoItemHasAllNetworkAddresses
};